export default {"src":"/_next/static/media/SHOP.44c24509.svg","height":18,"width":18};